import {ErrorInfo, Component, ReactNode} from 'react';

import Button from './Button/Button';
import s from './styles.module.scss';

export default class ErrorBoundary extends Component<
  {children: ReactNode; errorBody?: ReactNode},
  {error?: Error}
> {
  state = {
    error: undefined,
  };

  static getDerivedStateFromError(error: Error) {
    return {error};
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.warn(errorInfo);
    this.setState({error});
  }

  render() {
    const {error} = this.state;
    const {errorBody} = this.props;

    if (error) {
      if (errorBody) {
        return errorBody;
      }

      return (
        <div className={s['error-boundary']}>
          <img src="/img/error-boundary.png" alt="Something went wrong" />
          <h2 className={s['error-boundary__title']}>Something went wrong</h2>
          <p className={s['error-boundary__content']}>We already working on it!</p>
          <Button className={s['error-boundary__button']} onClick={() => window.location.reload()}>
            Reload
          </Button>
        </div>
      );
    }

    return this.props.children;
  }
}
